import React, {useEffect, useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {useFirebase, useFirestore} from 'react-redux-firebase'
import {Popup, Icon, Label, Loader, Menu, Button, Placeholder, Table} from 'semantic-ui-react'
import * as StructureActions from '../../actions/StructureActions'
import * as moment from 'moment';
import * as Sportradar from './sportradar'

function EventProperties(props){
    const event = props.event;

    return <div>
        <Table basic='very' celled collapsing>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Eigenschaft</Table.HeaderCell>
                    <Table.HeaderCell>Wert</Table.HeaderCell>
                    <Table.HeaderCell>UID</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                <Table.Row>
                    <Table.Cell>Sportart</Table.Cell>
                    <Table.Cell>{event.sport.name}</Table.Cell>
                    <Table.Cell>{event.sport.uid}</Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell>Land</Table.Cell>
                    <Table.Cell>{event.category.name}</Table.Cell>
                    <Table.Cell>{event.category.uid} / {event.category['category-in-sport-uid']}</Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell>Liga</Table.Cell>
                    <Table.Cell>{event.tournament.name}</Table.Cell>
                    <Table.Cell>{event.tournament.uid}</Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell>ID</Table.Cell>
                    <Table.Cell>{event['oddset-id']}</Table.Cell>
                    <Table.Cell>{event['uid']}</Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell>Datum</Table.Cell>
                    <Table.Cell>{moment(event['active-to-utc'].toDate()).format('dddd, DD.MM.YYYY [um] HH:mm [Uhr]')}</Table.Cell>
                    <Table.Cell></Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell>Plus</Table.Cell>
                    <Table.Cell>{event['plus-id']}</Table.Cell>
                    <Table.Cell></Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell>Kompakt</Table.Cell>
                    <Table.Cell>{event['kompakt-id']}</Table.Cell>
                    <Table.Cell></Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell>Version</Table.Cell>
                    <Table.Cell>{event['version']}</Table.Cell>
                    <Table.Cell></Table.Cell>
                </Table.Row>
            </Table.Body>
        </Table>
    </div>
}

export function Eventdetails(props){
    const firestore = useFirestore();
    const dispatch = useDispatch();

    const [activeItem, setActiveItem] = useState(0);

    const event = useSelector((state) => {
        let selectedTournament = state.structure.getIn(['selected', 'tournament']);
        let selected = state.structure.getIn(['selected', 'event']);
        if(typeof selected === 'undefined' || selected === null)return null;
        if(typeof selectedTournament === 'undefined' || selectedTournament === null)return null;

        if(!state.structure.hasIn(['events', selectedTournament]))return null;
        let events = Object.values(state.structure.getIn(['events', selectedTournament]).toJS());
        
        for(var event of events)
            if(event['uid'] === selected)return event;
        return null;
    })

    if(event === null)return null;

    return (
        <div style={{
            margin: '20px',
            width: '100%'
        }}>
            <h1>{event.name}</h1>

            <Menu pointing secondary>
                <Menu.Item active={activeItem === 0} onClick={() => setActiveItem(0)}>
                    Allgemein
                </Menu.Item>
                <Menu.Item active={activeItem === 1} onClick={() => setActiveItem(1)}>
                    Märkte
                </Menu.Item>
                <Menu.Item active={activeItem === 2} onClick={() => setActiveItem(2)}>
                    Tabelle
                </Menu.Item>
                <Menu.Item active={activeItem === 3} onClick={() => setActiveItem(3)}>
                    Prematch
                </Menu.Item>
                <Menu.Item active={activeItem === 4} onClick={() => setActiveItem(4)}>
                    Live
                </Menu.Item>
            </Menu>

            {
                (activeItem === 0)?
                <EventProperties event={event} />
                :null
            }
            {
                (activeItem === 2)?
                    <Sportradar.Leaguetable id={event['betradar-id']} />
                :null
            }
            {
                (activeItem === 3)?
                    <Sportradar.Prematch id={event['betradar-id']} />
                :null
            }
            {
                (activeItem === 4)?
                    <Sportradar.Live id={event['betradar-id']} />
                :null
            }
        </div>
    )

}